import { AxiosResponse } from "axios";
import { Requests } from "../../config/api";
import { getRequest } from "../commonActions/get";
import { patchRequest } from "../commonActions/update";

export const GetBookingData = async (page:number, limit:number)  => {
    console.log('query')
    try {
     
      const response: AxiosResponse = await getRequest({
        route: `${Requests.get.getBooking}?page=${page}&limit=${limit}`,
      });
      
  
     console.log('respon', response)
      const booking = response?.data?.bookings;
      const status = response?.status;
      const success = response?.data.success
      const message = response?.data?.message;
      const errors = response?.data?.message;
      const totalData = response.data.totalData
  
      return {
        status: status,
        booking,
        errors,
        message: message,
        success,
        totalData,
      };
    } catch (error) {
    
      throw error;
    }
  };


export const DeclineBooking = async (id:any): Promise<any> => {
 
    try {
     
      const response: AxiosResponse = await patchRequest({
        route: `${Requests.update.declineBooking}/${id}`,
      });
      console.log('res', response)
      const booking = response.data.booking
      const status = response?.status;
      const message = response?.data?.message;
      const errors = response?.data?.errors;
      const success = response.data.success
    
      return {
          booking,
          status,
          message,
          errors,
          success
      };
    } catch (error) {
      
      throw error;
    }
  };

  export const GetBookingFilter = async (
    page: number,
    limit: number,
    title?: string,
    referenceCode?: string,
    startingDate?: string,
    endingDate?: string
  ) => {
    try {
      
      const queryParams = new URLSearchParams();
  
      queryParams.append("page", String(page));
      queryParams.append("limit", String(limit));
  
      if (title) queryParams.append("title", title);
      if (referenceCode) queryParams.append("referenceCode", referenceCode);
      if (startingDate) queryParams.append("startingDate", startingDate);
      if (endingDate) queryParams.append("endingDate", endingDate);
  
      // Form the complete route with query parameters
      const route = `${Requests.get.getBookingFilter}?${queryParams.toString()}`;
  
      const response: AxiosResponse = await getRequest({
        route,
      });
  
      console.log("response", response);
  
      const booking = response?.data?.bookings;
      const status = response?.status;
      const success = response?.data.success;
      const message = response?.data?.message;
      const errors = response?.data?.message;
      const totalData = response?.data?.totalData;
  
      return {
        status: status,
        booking,
        errors,
        message: message,
        success,
        totalData,
      };
    } catch (error) {
      throw error;
    }
  };
  
